// extracted by mini-css-extract-plugin
export default {"toggle":"BuyAdminThemeToggle_toggle__zZzA6","label":"BuyAdminThemeToggle_label__CWoho","iconOnly":"BuyAdminThemeToggle_iconOnly__X6QN+"};